export const comments_3278340 = {"data":{"data":[],"links":{}}}